module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center component"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.payment-code-confirmation')))]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.bookingnumber')) + ":")]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.number))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bb32af8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PayedWithCodeConfirmationPage.vue
// module id = 987
// module chunks = 0